<template>
  <el-card class="h-full" :body-style="{ height: '100%', overflow: 'auto' }">
    <div class="mb-20px">
      <el-input
        size="small"
        clearable
        placeholder="栏目名称"
        class="!w-250px mr-10px"
        v-model="keyword"
      />
      <el-button size="small" type="primary" @click="searchList">搜索</el-button>
      <el-button size="small" @click="reset">重置</el-button>
    </div>
    <el-table
      height="calc(100% - 57px)"
      :data="filterTableData"
      v-loading="tableLoading"
      ref="table"
      border
      row-key="id"
      :tree-props="{ children: 'child', hasChildren: 'isLeaf' }"
      default-expand-all
    >
      <el-table-column label="栏目名称" prop="name" show-overflow-tooltip></el-table-column>
      <el-table-column label="是否统计稿费" prop="name" width="120">
        <template slot-scope="scope">
          {{ scope.row.isComputeRoyalties ? '是' : '否' }}
        </template>
      </el-table-column>
      <el-table-column
        label="默认稿件类别"
        prop="royaltiesCategoryName"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="默认稿件类型"
        prop="royaltiesTypeName"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="默认稿件级别"
        prop="royaltiesLevelName"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="默认稿费" prop="configRoyaltiesLevel" width="100"></el-table-column>
      <el-table-column label="配照片（元/篇）" prop="withImage" width="130"></el-table-column>
      <el-table-column label="操作" width="75">
        <template slot-scope="scope">
          <el-button
            size="mini"
            :disabled="!$hasAccess('update')"
            @click="updateRow(scope.row)"
            v-if="scope.row.isLeaf"
          >
            编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="栏目默认稿费设置"
      class="small-dialog"
      :visible.sync="dialogVisible"
      v-dialogDrag
      :before-close="closeDialog"
    >
      <div>
        <el-form label-width="150px" label-position="right" :model="form" ref="form">
          <el-form-item
            label="是否计算稿费"
            prop="isComputeRoyalties"
            :rules="[{ required: true, message: '请选择是否计算稿费', trigger: 'change' }]"
          >
            <el-radio-group v-model="form.isComputeRoyalties">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <template v-if="form.isComputeRoyalties">
            <el-form-item
              label="默认稿件类别"
              prop="royaltiesCategoryId"
              :rules="[{ required: true, message: '请选择默认稿件类别', trigger: 'change' }]"
            >
              <el-select
                v-model="form.royaltiesCategoryId"
                clearable
                popper-class="select-popper"
                filterable
                placeholder="请选择默认稿件类别"
                @change="getRoyalties"
              >
                <el-option
                  v-for="item in royaltiesCategory"
                  :key="item.id"
                  :label="item.displayName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="默认稿件类型"
              prop="royaltiesTypeId"
              :rules="[{ required: true, message: '请选择默认稿件类型', trigger: 'change' }]"
            >
              <el-select
                v-model="form.royaltiesTypeId"
                clearable
                popper-class="select-popper"
                filterable
                placeholder="请选择默认稿件类型"
                @change="getRoyalties"
              >
                <el-option
                  v-for="item in royaltiesType"
                  :key="item.id"
                  :label="item.displayName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="默认稿件级别"
              prop="royaltiesLevel"
              :rules="[{ required: true, message: '请选择默认稿件级别', trigger: 'change' }]"
            >
              <el-select
                v-model="form.royaltiesLevel"
                clearable
                popper-class="select-popper"
                filterable
                placeholder="请选择默认稿件级别"
                @change="getRoyalties"
              >
                <el-option
                  v-for="item in royaltiesLeavel"
                  :key="item.id"
                  :label="item.displayName"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="稿费（元/篇）" prop="configRoyaltiesLevel">
              <el-input v-model="form.configRoyaltiesLevel" disabled placeholder="自动计算" />
            </el-form-item>
            <el-form-item label="配照片（元/篇）" prop="withImage">
              <el-input v-model="form.withImage" disabled placeholder="自动计算" />
            </el-form-item>
          </template>
        </el-form>
      </div>
      <div slot="footer" class="flex justify-center items-center">
        <el-button type="primary" :loading="btnLoading" @click="save">保存</el-button>
        <el-button @click="closeDialog()">取消</el-button>
      </div>
    </el-dialog>
  </el-card>
</template>

<script>
import { RoyaltiesConfigApi, RoyaltiesStandardApi } from '@wiz-api/workbench'
import { DataCategoryApi } from '@wiz-api/data-category-management'

const royaltiesConfigApi = new RoyaltiesConfigApi()
const dataCategoryApi = new DataCategoryApi()
const royaltiesStandardApi = new RoyaltiesStandardApi()
export default {
  data() {
    return {
      keyword: '',
      tableData: [],
      filterTableData: [],
      tableLoading: false,
      dialogVisible: false,
      btnLoading: false,
      royaltiesCategory: [],
      royaltiesType: [],
      royaltiesLeavel: [],
      form: {
        isComputeRoyalties: false,
      },
      standardData: [],
    }
  },
  mounted() {
    this.searchList()
    this.getDataCategory()
    this.getStandardData()
  },
  methods: {
    async getStandardData() {
      const [err, res] = await royaltiesStandardApi.getRoyaltiesStandard()
      if (!err && res) {
        this.standardData = res
      }
    },
    async searchList() {
      this.tableLoading = true
      const [err, res] = await royaltiesConfigApi.tree()
      this.tableLoading = false
      if (!err) {
        this.tableData = res
        this.filterTableData = this.filterTreeData(this.tableData, this.keyword)
      }
    },
    reset() {
      this.keyword = ''
      this.searchList()
    },
    filterTreeData(data, filterText) {
      if (!filterText) return data
      const filteredData = []
      data.forEach((node) => {
        if (node.name.includes(filterText)) {
          filteredData.push(node)
        }
        if (node.child) {
          const childrenFiltered = this.filterTreeData(node.child, filterText)
          if (childrenFiltered.length > 0) {
            filteredData.push({ ...node, child: childrenFiltered })
          }
        }
      })
      return filteredData
    },
    updateRow(row) {
      this.form = _.pick(row, [
        'id',
        'configId',
        'royaltiesCategoryId',
        'royaltiesTypeId',
        'royaltiesLevel',
        'isComputeRoyalties',
        'withImage',
        'configRoyaltiesLevel',
      ])
      this.dialogVisible = true
    },
    getRoyalties() {
      if (this.form.royaltiesCategoryId && this.form.royaltiesTypeId && this.form.royaltiesLevel) {
        const level = _.find(this.royaltiesLeavel, { id: this.form.royaltiesLevel })
        const levelFields = {
          1: 'groupLevel',
          2: 'provinceLevel',
          0: 'companyLevel',
        }
        const levelField = levelFields[level.code]
        const standard = _.find(this.standardData, (item) => {
          return (
            item.categoryId === this.form.royaltiesCategoryId &&
            item.typeId === this.form.royaltiesTypeId
          )
        })
        if (standard) {
          this.form.withImage = standard.withImage
          this.form.configRoyaltiesLevel = standard[levelField]
        }
      }
    },
    async getDataCategory() {
      const param = {
        code: 'RoyaltiesCategory',
        includeDetails: true,
      }
      const [err, res] = await dataCategoryApi.getByCode(param)
      if (!err && res) {
        this.royaltiesCategory = res.dataItems
      }

      const params = {
        code: 'RoyaltiesType',
        includeDetails: true,
      }
      const [errType, resType] = await dataCategoryApi.getByCode(params)
      if (!errType && resType) {
        this.royaltiesType = resType.dataItems
      }

      const paramresLeavel = {
        code: 'RoyaltiesLevel',
        includeDetails: true,
      }
      const [errLeavel, resLeavel] = await dataCategoryApi.getByCode(paramresLeavel)
      if (!errLeavel && resLeavel) {
        this.royaltiesLeavel = resLeavel.dataItems
      }
    },
    save() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          this.btnLoading = true
          const body = _.pick(this.form, [
            'royaltiesCategoryId',
            'royaltiesTypeId',
            'royaltiesLevel',
            'isComputeRoyalties',
          ])
          body.columnId = this.form.id
          if (this.form.configId) {
            body.id = this.form.configId
          }
          const [err] = await royaltiesConfigApi.saveRoyaltiesConfig({
            body,
          })
          this.btnLoading = false
          if (!err) {
            this.$message.success('保存成功')
            this.dialogVisible = false
            this.searchList()
          }
        }
      })
    },
    closeDialog(done) {
      this.form = this.$options.data().form
      this.$refs.form.clearValidate()
      if (done) {
        done()
      } else {
        this.dialogVisible = false
      }
    },
  },
}
</script>

<style lang="scss" scoped></style>
